export const API_BASE_URL = "https://v2.api.noroff.dev/";

